import React, { useState } from 'react';
import {
  Typography,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import logo from '../../assets/images/logo.png'; // eslint-disable-line no-unused-vars
import PremiumHeader from '../../components/Header/PremiumHeader';

// Import Work Images
import work1 from '../../assets/works/work1.jpg';
import work2 from '../../assets/works/work2.jpg';
import work3 from '../../assets/works/work3.jpg';
import work4 from '../../assets/works/work4.jpg';
import work5 from '../../assets/works/work5.jpg';
import work6 from '../../assets/works/work6.jpg';
import work7 from '../../assets/works/work7.jpg';
import work8 from '../../assets/works/work8.jpg';
import work9 from '../../assets/works/work9.jpg';
import work10 from '../../assets/works/work10.jpg';

import '../common.css';
import './projects.css';
import Footer from '../../components/Footer/Footer';

const ProjectsPage = () => {
  const navigate = useNavigate();
  const [expandedProject, setExpandedProject] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const handleNavClick = (e, path) => {
    e.preventDefault();
    const routes = {
      home: '/', about: '/about', services: '/services', projects: '/projects',
      clients: '/clients', contact: '/contact',
      careers: '/careers', hireus: '/hireus'
    };
    navigate(routes[path] || '/');
  };

  const projects = [
    {
      id: 1,
      title: 'Boiler Installation & Piping Works',
      image: work1,
      category: 'Thermal Power Plant',
      status: 'Completed',
      scope: 'Complete boiler mechanical installation with IBR certified piping systems',
      details: [
        'Boiler shell erection and pressure testing',
        'High-pressure piping installation (MS, CS, SS)',
        'Superheater and reheater tube bundles',
        'All welding performed by IBR certified welders',
        'Complete NDT and pressure vessel inspection'
      ],
      timeline: '6 Months',
      client: 'NTPC / Adani Power',
      location: 'Multiple Locations (India)',
      technologies: ['IBR Welding', 'NDT Testing', 'Hydrostatic Testing'],
      specifications: 'Pipe range: 25mm - 2000mm | Pressure: Up to 250 bar | Temperature: Up to 540°C'
    },
    {
      id: 2,
      title: 'Ash Hopper Fabrication & Installation',
      image: work2,
      category: 'Ash Management System',
      status: 'Completed',
      scope: 'Heavy steel hopper fabrication with refractory lining and discharge gates',
      details: [
        'Bottom ash hopper steel structure fabrication',
        'Refractory lining installation',
        'Hydraulic gate assembly and sealing',
        'Insulation wrapping and supports',
        'Complete hydraulic system integration'
      ],
      timeline: '4 Months',
      client: 'Vedanta / NTPC',
      location: 'Jharsuguda, Odisha',
      technologies: ['Heavy Steel Fabrication', 'Refractory Lining', 'Hydraulic Systems'],
      specifications: 'Hopper capacity: 1500-3000T | Material: Mild Steel + Stainless Steel | Weight: Up to 200 tons'
    },
    {
      id: 3,
      title: 'ESP Electrode & Hopper Works',
      image: work3,
      category: 'Electrostatic Precipitator',
      status: 'Completed',
      scope: 'Complete ESP internal components including electrodes and gas distribution screens',
      details: [
        'Electrode frame and wire installation',
        'Gas distribution (GD) screen fabrication',
        'Hamper and rapping system installation',
        'Filter bag housing and internal linings',
        'Precision alignment and testing'
      ],
      timeline: '3 Months',
      client: 'Tata Power / CLP India',
      location: 'Multiple Locations',
      technologies: ['Precision Welding', 'Electrode Assembly', 'Alignment Engineering'],
      specifications: 'Electrode spacing: 100-150mm | GD Screen: Custom sized | Collection efficiency: 99.5%'
    },
    {
      id: 4,
      title: 'Cooling Tower Mechanical Assembly',
      image: work4,
      category: 'Cooling Systems',
      status: 'Completed',
      scope: 'FRP cooling tower erection with mechanical systems and piping',
      details: [
        'Cooling tower shell assembly and alignment',
        'Fan deck and drive system installation',
        'Water distribution piping system',
        'Large bore piping (dia 1000mm - 3000mm)',
        'Pump and circulation system integration'
      ],
      timeline: '5 Months',
      client: 'Adani Power / NTPC',
      location: 'Gujarat & Jharkhand',
      technologies: ['Large Bore Piping', 'Mechanical Assembly', 'Hydraulic Systems'],
      specifications: 'Tower capacity: 5000-15000 M³/hr | Piping range: Up to 3000mm | Temperature rating: Up to 45°C'
    },
    {
      id: 5,
      title: 'Conveyor System Installation',
      image: work5,
      category: 'Coal Handling',
      status: 'Completed',
      scope: 'Long-distance conveyor system installation with structural supports',
      details: [
        'Conveyor frame and structure fabrication',
        'Belt tensioning and alignment',
        'Drive pulley and idler roller installation',
        'Transfer chute and discharge systems',
        'Safety railing and access platforms'
      ],
      timeline: '4 Months',
      client: 'NTPC / Lanco Infratech',
      location: 'Coal Handling Plants (India)',
      technologies: ['Structural Fabrication', 'Mechanical Conveying', 'Belt Alignment'],
      specifications: 'Conveyor length: Up to 5km | Belt width: 800-2000mm | Capacity: 1000-3000 TPH'
    },
    {
      id: 6,
      title: 'Chimney Shell Erection Works',
      image: work6,
      category: 'Chimney Systems',
      status: 'Completed',
      scope: 'High-rise steel chimney erection with platforms and ladders',
      details: [
        'Steel shell plate rolling and welding',
        'Chimney foundation to top assembly',
        'Internal flue gas ducting',
        'Platforms, ladders, and cage installation',
        'Expansion joint and thermal insulation'
      ],
      timeline: '6 Months',
      client: 'BHEL / NTPC Sagardigi',
      location: 'West Bengal & Jharkhand',
      technologies: ['High-Rise Welding', 'Structural Assembly', 'Thermal Insulation'],
      specifications: 'Chimney height: Up to 275m | Shell diameter: 4-8m | Plate thickness: 8-25mm'
    },
    {
      id: 7,
      title: 'Boiler Auxiliary Systems Installation',
      image: work7,
      category: 'Thermal Power Plant',
      status: 'Completed',
      scope: 'Installation of economizer, air heater, and associated piping systems',
      details: [
        'Economizer tube bundle installation',
        'Air pre-heater (APH) assembly and alignment',
        'Gas inlet and outlet ducting',
        'Steam piping and condensate systems',
        'Instrumentation and control line routing'
      ],
      timeline: '3 Months',
      client: 'Toshiba / Adani Power',
      location: 'Multiple Thermal Plants',
      technologies: ['Heat Exchanger Installation', 'Gas Piping', 'Instrumentation'],
      specifications: 'Economizer tubes: 100-300 per unit | APH type: Rotary/Ljungstrom | Capacity: 100-800MW'
    },
    {
      id: 8,
      title: 'Structural Works & Platforms',
      image: work8,
      category: 'Industrial Structures',
      status: 'Completed',
      scope: 'Heavy structural fabrication and erection for power plant infrastructure',
      details: [
        'Boiler support structure design and fabrication',
        'Multi-level platforms and mezzanines',
        'Staircase and railing systems',
        'Equipment mounting and alignment',
        'Seismic design compliance'
      ],
      timeline: '5 Months',
      client: 'Adani Power / NTPC',
      location: 'Power Generation Sites',
      technologies: ['Structural Steel Fabrication', 'Heavy Lifting', 'Precision Alignment'],
      specifications: 'Heights: Up to 120m | Steel grade: IS 2062 | Welding standard: IS 1599 (AWS D1.1)'
    },
    {
      id: 9,
      title: 'FGD System Piping & Equipment',
      image: work9,
      category: 'Environmental Systems',
      status: 'Completed',
      scope: 'Flue gas desulfurization system with limestone slurry piping',
      details: [
        'Slurry piping network installation',
        'Sea water and cooling water piping',
        'Gypsum disposal piping systems',
        'Pump and circulation equipment',
        'Monitoring and control systems'
      ],
      timeline: '4 Months',
      client: 'CLP India / Vedanta',
      location: 'Thermal Power Plants (India)',
      technologies: ['Slurry Piping', 'Large Bore Piping', 'Corrosion Resistant Systems'],
      specifications: 'Piping range: 25mm-2000mm | Slurry concentration: 5-30% | Pressure: Up to 100 bar'
    },
    {
      id: 10,
      title: 'Plant Shutdown & Maintenance Works',
      image: work10,
      category: 'Maintenance Services',
      status: 'Completed',
      scope: 'Comprehensive planned shutdown maintenance and equipment overhaul',
      details: [
        'Boiler tube replacement and inspection',
        'Turbine rotor and blade examination',
        'ESP electrode replacement',
        'All piping system inspection and testing',
        'Equipment alignment and balancing'
      ],
      timeline: '15-30 Days per cycle',
      client: 'NTPC / Adani Power',
      location: 'Multiple Operational Plants',
      technologies: ['NDT Inspection', 'Precision Alignment', 'Rotating Equipment Overhaul'],
      specifications: 'Plant units: 120MW - 800MW | Manpower: 200-500 skilled technicians | Downtime: Minimized'
    }
  ];

  // Handler functions
  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setSelectedIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const handleLightboxBackdropClick = (e) => {
    if (e.target.className === 'project-lightbox-backdrop') {
      handleCloseLightbox();
    }
  };

  const handlePrevImage = () => {
    const newIndex = selectedIndex === 0 ? projects.length - 1 : selectedIndex - 1;
    setSelectedIndex(newIndex);
    setSelectedImage(projects[newIndex].image);
  };

  const handleNextImage = () => {
    const newIndex = selectedIndex === projects.length - 1 ? 0 : selectedIndex + 1;
    setSelectedIndex(newIndex);
    setSelectedImage(projects[newIndex].image);
  };

  // Handle keyboard for lightbox
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && lightboxOpen) {
        handleCloseLightbox();
      }
      if (e.key === 'ArrowLeft' && lightboxOpen) {
        handlePrevImage();
      }
      if (e.key === 'ArrowRight' && lightboxOpen) {
        handleNextImage();
      }
    };

    if (lightboxOpen) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [lightboxOpen, selectedIndex]);

  return (
    <div className="routed-page">
      <PremiumHeader />

      <div className="page-header-section">
        <Typography className="page-title">
          Our Projects Portfolio
        </Typography>
        <Typography className="page-subtitle">
          Showcasing Excellence in Mechanical Construction & Industrial Services
        </Typography>
      </div>

      <div className="page-container content-wrapper">
        <div className="back-button-container">
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>

        <Grid
          container
          spacing={3}
          className="projects-grid"
        >
          {projects.map((project, index) => (
            <Grid item xs={12} sm={12} md={6} key={project.id}>
              <Card 
                className="project-card"
                onClick={() => setExpandedProject(expandedProject === project.id ? null : project.id)}
              >
                <CardMedia
                  component="img"
                  height="280"
                  image={project.image}
                  alt={project.title}
                  className="project-image"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleImageClick(project.image, index);
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <CardContent className="project-content">
                  <Box className="project-header">
                    <Typography variant="caption" className="project-category">
                      {project.category}
                    </Typography>
                    <Typography variant="caption" className={`project-status ${project.status.toLowerCase().replace(' ', '-')}`}>
                      {project.status}
                    </Typography>
                  </Box>
                  <Typography variant="h6" className="project-title">
                    {project.title}
                  </Typography>
                  <Typography variant="body2" className="project-description">
                    {project.scope}
                  </Typography>

                  {/* Expandable Details */}
                  {expandedProject === project.id && (
                    <Box className="project-details-expanded">
                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Key Details:</Typography>
                        {project.details.map((detail, idx) => (
                          <Typography key={idx} variant="body2" className="detail-item">
                            ✓ {detail}
                          </Typography>
                        ))}
                      </Box>

                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Timeline:</Typography>
                        <Typography variant="body2">{project.timeline}</Typography>
                      </Box>

                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Client:</Typography>
                        <Typography variant="body2">{project.client}</Typography>
                      </Box>

                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Location:</Typography>
                        <Typography variant="body2">{project.location}</Typography>
                      </Box>

                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Technologies:</Typography>
                        <Box className="tech-tags">
                          {project.technologies.map((tech, idx) => (
                            <Typography key={idx} variant="caption" className="tech-tag">
                              {tech}
                            </Typography>
                          ))}
                        </Box>
                      </Box>

                      <Box className="detail-section">
                        <Typography variant="subtitle2" className="detail-label">Specifications:</Typography>
                        <Typography variant="body2" className="spec-text">{project.specifications}</Typography>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box className="projects-summary">
          <Typography variant="h5" className="summary-title">
            Why Choose Our Projects?
          </Typography>
          <Grid container spacing={2} className="summary-grid">
            <Grid item xs={12} sm={6} md={3}>
              <Box className="summary-item">
                <Typography variant="h4" className="summary-number">50+</Typography>
                <Typography variant="body2">Major Projects Executed</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box className="summary-item">
                <Typography variant="h4" className="summary-number">14+</Typography>
                <Typography variant="body2">Years of Expertise</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box className="summary-item">
                <Typography variant="h4" className="summary-number">100%</Typography>
                <Typography variant="body2">On-Time Delivery</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box className="summary-item">
                <Typography variant="h4" className="summary-number">500+</Typography>
                <Typography variant="body2">Skilled Workforce</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Project Lightbox Modal */}
        {lightboxOpen && (
          <div className="project-lightbox-backdrop" onClick={handleLightboxBackdropClick}>
            <div className="project-lightbox-container">
              <button className="project-lightbox-close" onClick={handleCloseLightbox}>
                ✕
              </button>
              <div className="project-lightbox-content">
                <img src={selectedImage} alt="enlarged" className="project-lightbox-image" />
              </div>
              <button className="project-lightbox-nav project-lightbox-prev" onClick={handlePrevImage}>
                ❮
              </button>
              <button className="project-lightbox-nav project-lightbox-next" onClick={handleNextImage}>
                ❯
              </button>
              <div className="project-lightbox-counter">
                {selectedIndex + 1} / {projects.length}
              </div>
              <div className="project-lightbox-title">
                {projects[selectedIndex].title}
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
